import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { paymentFormAction } from "../../redux/rootReducer";
import { updatePaymentSagaAction } from "../../redux/sagaActions";
import Payment from "../Payment/Payment";
import { PAYMENT_FORM_INITIAL } from "../../redux/initialStateConstant";
import CalendarOffline from "../CalendarOffline/CalendarOffline";

const PaymentForm = () => {
    const dispatch = useDispatch();
    const paymentForm = useSelector(state => state.paymentForm);

    // Состояние календаря
    const [openCalendar, setOpenCalendar] = useState(false);

    if (!paymentForm.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(paymentFormAction(PAYMENT_FORM_INITIAL)) }/>
                        <div className="form__title">{ `Платёж № ${ paymentForm.id }` }</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Дата платежа</div>
                        <div className="input"
                            onClick={ event => {
                                event.preventDefault();
                                event.stopPropagation();
                                setOpenCalendar(true);
                            } }
                        >{ new Date(paymentForm.date).toLocaleDateString('ru-Ru') }</div>
                        <CalendarOffline
                            handler={ date => {
                                dispatch(paymentFormAction({
                                    ...paymentForm,
                                    date
                                }));
                                setOpenCalendar(false);
                            } }
                            open={ openCalendar }
                            close={ () => setOpenCalendar(false) }
                        />
                    </div>
                    <div className="form__field"/>
                    <Payment
                        payment={ paymentForm.payment }
                        totalSum={ paymentForm.total_sum }
                        discountValue={ paymentForm.discount }
                        handler={ ({ payment, discount, total_sum }) => dispatch(paymentFormAction({
                            ...paymentForm,
                            payment,
                            discount,
                            total_sum
                        })) }
                    />
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                let formattedPayments = [];
                                // Фильтруем и форматируем платежи
                                paymentForm.payment.forEach(el => {
                                    if (el.cost) {
                                        formattedPayments.push({ cost: el.cost, payment_method: el.payment_method.id });
                                    }
                                });
                                dispatch(updatePaymentSagaAction({
                                    payment_id: paymentForm.id,
                                    payment: JSON.stringify(formattedPayments),
                                    discount: paymentForm.discount.id,
                                    date: paymentForm.date
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentForm;